<template>
    <div>
        <div class="vx-row">
            <div class="vx-col xl:w-1/3 w-full">
                <vx-card :title="location.name" id="dataDiv"  class="vs-con-loading__container">
                    <div v-if="editingDisabled">
                        <h5>{{location.address}}</h5>
                    </div>
                    <div v-else>
                        <p class="mt-6">Name</p>
                        <vs-input v-model="editObject['name']" class="w-full"></vs-input>
                        <p class="mt-6">Max connections</p>
                        <vs-input v-model="editObject['address']" class="w-full"></vs-input>
                    </div>
                    <vs-divider/>
                    <vs-button v-if="editingDisabled" style="float: left" color="warning" icon-pack="feather" icon="icon-edit" class="mb-3 mr-3" @click="editingDisabled = false"></vs-button>
                    <vs-button v-if="!editingDisabled" style="float: left" color="success" icon-pack="feather" icon="icon-save" class="mb-3 mr-3" @click="saveLocation">Save</vs-button>
                    <vs-button v-if="!editingDisabled" style="float: right" color="danger" icon-pack="feather" icon="icon-trash-2" class="mb-3 mr-3" @click="removeLocation">Remove</vs-button>
                </vx-card>
            </div>
        </div>
        <vs-divider/>
    </div>
</template>
<script>

    export default {
        data() {
            return {

                location: {
                    name: '',
                    address: 0
                },

                editingDisabled: true,
                editObject: {}

            }
        },
        methods: {
            loadData() {
                this.$vs.loading({
                    container: '#dataDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/location/' + this.$route.params.id)
                loadPromise.then(function(response) {
                    thisIns.location = response.data
                    thisIns.editObject = JSON.parse(JSON.stringify(response.data))
                    thisIns.$vs.loading.close('#dataDiv > .con-vs-loading')
                })

                loadPromise.catch(function(error) {
                    thisIns.$printError(error.response.data)
                    thisIns.$vs.loading.close('#dataDiv > .con-vs-loading')
                })
            },
            saveLocation() {
                this.$vs.loading({
                    container: '#dataDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const addPromise = this.$http.put('/api/management/v1/location/' + this.$route.params.id, {
                    name: this.editObject.name,
                    address: this.editObject.address
                })

                addPromise.then(function() {
                    thisIns.editingDisabled = true
                    thisIns.$printSuccess('Location saved')
                    thisIns.loadData()
                })

                addPromise.catch(function(error) {
                    thisIns.$printError(error.response.data)
                    thisIns.$vs.loading.close('#dataDiv > .con-vs-loading')
                })
            },
            removeLocation() {
                this.$vs.loading({
                    container: '#dataDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.delete('/api/management/v1/location/' + this.$route.params.id)
                loadPromise.then(function() {
                    thisIns.$printSuccess('Location removed')
                    thisIns.$vs.loading.close('#dataDiv > .con-vs-loading')
                    thisIns.$nextTick(() => {
                        thisIns.$router.push('/locations/')
                    })
                })

                loadPromise.catch(function(error) {
                    thisIns.$printError(error.response.data)
                    thisIns.$vs.loading.close('#dataDiv > .con-vs-loading')
                })
            }
        },
        mounted() {
            this.loadData()
        }
    }

</script>
